import graphql from "babel-plugin-relay/macro";

export const HomeContentQuery = graphql`
  query HomeContentQuery {
    pendingDocuments(showAll: false) {
      documents(first: 5) {
        totalCount
        edges {
          node {
            id
            pk
            name
            bloc {
              name
            }
            applicabilityType
            category {
              name
            }
            effectiveDate
            restricted
            legacyEffectiveDate
          }
        }
      }
      viewOnlyPks
    }
    documentsToReviewHome {
      documents {
        pk
        name
        bloc {
          name
        }
        applicabilityType
        category {
          name
        }
        expirationDate
        restricted
      }
      totalCount
      buckets
    }
    myDocumentsToAcknowledge(first: 5) {
      totalCount
      edges {
        node {
          totalAcknowledged
          totalAssigned
          line {
            pk
            document {
              pk
              name
              hasAttachments
              effectiveDate
              legacyEffectiveDate
              restricted
              category {
                name
              }
              bloc {
                name
              }
              applicabilityType
            }
          }
        }
      }
    }
    recentlyRevisedDocuments {
      documents(first: 5) {
        totalCount
        edges {
          node {
            pk
            name
            bloc {
              name
            }
            category {
              name
            }
            bloc {
              name
            }
            applicabilityType
            revisedFromParent
            effectiveDate
            legacyEffectiveDate
            restricted
            revisedFromParentStatus
          }
        }
      }
      buckets
    }
    blocSystemDocumentTemplatesAcceptance {
      blocSystemDocumentTemplates(first: 5) {
        totalCount
        edges {
          node {
            systemDocumentTemplate {
              pk
              name
              category {
                name
              }
            }
            publishDate
            document {
              pk
            }
          }
        }
      }
      buckets
    }
    currentTenant {
      ...HomeContent_currentTenant
    }
  }
`;
